import { ProfileItemModel } from './profile-item.model';

export class ProfileSectionModel {
    heading: string;
    items: ProfileItemModel[];

    constructor(heading?: string, items?: ProfileItemModel[]) {
        this.heading = heading;
        this.setItems(items);
    }

    setItems(items: ProfileItemModel[]) {
        this.items = items.filter(item => {
            if (Array.isArray(item.content)) {
                return item.content.length > 0;
            }
            return !!item.content;
        });
    }
}
